import React from 'react'

import Login from '../Account/Login.jsx'
import Register from '../Account/Register.jsx'

// import './sign-in-and-sign-up.styles.scss'

const LoginAndRegisterPage = () => (

    <div className='login-and-register'>
        <div className="box-container">

            <Login />
            <Register />
        </div>
    </div>
)

export default LoginAndRegisterPage